import React from 'react';
import './MessageBubble.css';

const MessageBubble = ({ message }) => {
  const { text, sender, timestamp } = message;
  
  const formatTime = (date) => {
    return new Date(date).toLocaleTimeString([], { 
      hour: '2-digit', 
      minute: '2-digit' 
    });
  };

  const getAvatar = (sender) => {
    return sender === 'user' ? '👤' : '🤖';
  };

  return (
    <div className={`message-bubble ${sender}`}>
      <div className="message-content">
        <div className="message-avatar">
          {getAvatar(sender)}
        </div>
        <div className="message-text-container">
          <div className="message-text">{text}</div>
          <div className="message-time">{formatTime(timestamp)}</div>
        </div>
      </div>
    </div>
  );
};

export default MessageBubble;